










import { Vue, Component } from "vue-property-decorator";

import { portfolioStore } from "@/portfolio/store";
import { Performance, Portfolio } from "./types";
@Component
export default class PortfolioPage extends Vue {
  state: "idle" | "busy" | "done" = "idle";

  async created() {
    this.state = "busy";
    if (portfolioStore.state.items.length === 0) {
      await portfolioStore.loadPortfolio();
    }
    this.state = "idle";
  }
}
